import { MenuItem } from '@mui/material';
import React, { useState } from 'react';

import { getTranslateByKey } from '@/main/services/utils';

import { useThreeDotsClaimContext } from '../contex';
import WrapperModalBulkCancelClaim from '@/main/components/shared/modalBulkCancelClaim/modalBulkCancelClaim';
import { KeyValue } from '@/main/models/common';
import useKogControlElementId from '@/main/hooks/useKogControlElementId';
import { Controls } from '@/main/services/constants/constantsControl';

export interface IThreeDotsClaimCancelProps {
  guidClaim: string;
  showCancelButton: boolean;
  refreshClaim: () => void;
}

function ThreeDotsClaimCancel(props: IThreeDotsClaimCancelProps) {
  const {
    closeThreeDotsClaim,
    generateIdMenu,
  } = useThreeDotsClaimContext();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const showButtonCancel = useKogControlElementId(Controls.IdCancelPart) && props.showCancelButton;

  function handleClick() {
    setIsOpenModal(true)
    closeThreeDotsClaim();
  }
  function closeModal() {
    setIsOpenModal(false);
  }

  if (!showButtonCancel || !props.showCancelButton) return null;

  return (
    <>
      <MenuItem
        id={generateIdMenu('cancel')}
        onClick={handleClick}
      >
        {getTranslateByKey('information.cancel')}
      </MenuItem>

      <WrapperModalBulkCancelClaim
        isOpenModal={isOpenModal}
        closeModal={closeModal}
        setIsOpenModal={setIsOpenModal}
        {...props}
      />
    </>
  )
}

export { ThreeDotsClaimCancel };
